import { useTranslation } from 'react-i18next';

import { recordingNumberLabel } from '@/lib/audio';
import type { CadeAudioRecording } from '@/services/types';

/** "271ª SOJ · 2 de setembro de 2026", from CADE's own file name for the recording. */
export function useRecordingLabel() {
  const { i18n, t } = useTranslation(['cade']);
  return (recording: CadeAudioRecording): string => {
    const number = recordingNumberLabel(recording.kind, recording.number) || String(recording.year);
    // A session recorded in several files: each file is named by its part.
    const base = recording.part
      ? `${number} · ${t('cade:audio.part', { number: recording.part })}`
      : number;
    if (!recording.session_date) return `${base} · ${recording.year}`;
    const date = new Intl.DateTimeFormat(i18n.language, {
      dateStyle: 'medium',
      timeZone: 'UTC',
    }).format(new Date(`${recording.session_date}T00:00:00Z`));
    return `${base} · ${date}`;
  };
}
